<template>
  <div>
    <div class="el-section">
      <invite-detail-grid :invite="invite" />
    </div>
    <div class="el-section">
      <emd-card>
        <emd-card-header>
          <emd-text tag="h2">{{ $t('invite.detail.info') }}</emd-text>
          <template #actions>
            <div
              v-if="showActionsButton"
              id="jsDropdown"
              class="emd-dropdown _position_right"
            >
              <div class="emd-dropdown__trigger">
                <emd-button
                  color="primary"
                  size="small"
                  @click="toogleDropdown"
                  >{{ $t('users.detail.actions.title') }}</emd-button
                >
              </div>
              <div
                class="emd-dropdown__content"
                :class="{ _active: showActionsDropdown }"
              >
                <nav class="emd-nav-list _direction_column _hoverble">
                  <ul>
                    <li
                      class="emd-nav-list__item eu-no-padding eu-no-margin"
                      @click="openModal('RESEND_INVITE')"
                      v-if="showResendButton"
                    >
                      <emd-button
                        type="link"
                        color="primary"
                        class="eu-pa_3"
                        ><span class="uil uil-redo eu-pr_1" />{{
                          $t('invite.resend-invite')
                        }}
                      </emd-button>
                    </li>
                    <li
                      class="emd-nav-list__item eu-no-padding eu-no-margin"
                      @click="openModal('CANCEL_INVITE')"
                      v-if="showRemoveButton"
                    >
                      <emd-button
                        type="link"
                        color="danger"
                        class="eu-pa_3"
                        ><span class="uil uil-trash-alt eu-pr_1" />{{
                          $t('invite.cancel-invite')
                        }}
                      </emd-button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </template>
        </emd-card-header>

        <invite-alert
          v-if="alert.show"
          :alert="alert"
          @cancel="$emit('resetAlert')"
        />
        <invite-detail-infos :invite="invite" />
      </emd-card>
    </div>
    <modal-password
      v-if="modalOpenned"
      @cancel="closeModal"
      :callback="actionInvite"
    ></modal-password>
  </div>
</template>
<script>
import ModalPassword from '@/components/project/globals/ModalPassword.vue'
import { formatErrorMessage } from '@/support/formatErrorMessage'
import InviteAlert from '@/views/Team/Invites/components/InviteAlert.vue'
import {
  EmdCard,
  EmdCardHeader,
  EmdText,
  EmdButton
} from 'emerald-vue/src/components'
import { mapGetters } from 'vuex'
import {
  invitesRemoveEnabled,
  invitesResendEnabled
} from '@/actions-permission/invites.permissions'
import InviteDetailGrid from '@/views/Team/Invites/components/InviteDetailGrid.vue'
import InviteDetailInfos from '@/views/Team/Invites/components/InviteDetailInfos.vue'

export default {
  name: 'InvitesDetail',
  components: {
    InviteAlert,
    ModalPassword,
    EmdCard,
    EmdCardHeader,
    EmdText,
    EmdButton,
    InviteDetailGrid,
    InviteDetailInfos
  },
  props: {
    invite: Object
  },
  data () {
    return {
      modalOpenned: false,
      typeAction: null,
      showActionsDropdown: false,
      alert: {
        show: false,
        isError: false,
        messages: []
      }
    }
  },
  computed: {
    ...mapGetters(['permissionIsEnabled']),
    params () {
      return {
        inviteId: this.$route.params.id
      }
    },
    inviteId () {
      return this.$route.params.id
    },
    showActionsButton () {
      return this.showResendButton || this.showRemoveButton
    },
    showResendButton () {
      return (
        this.invite.showResendButton &&
        invitesResendEnabled(this.permissionIsEnabled)
      )
    },
    showRemoveButton () {
      return (
        this.invite.showRemoveButton &&
        invitesRemoveEnabled(this.permissionIsEnabled)
      )
    }
  },
  methods: {
    toogleDropdown () {
      this.showActionsDropdown = !this.showActionsDropdown
    },
    openModal: function (type) {
      this.showActionsDropdown = false
      this.modalOpenned = true
      this.typeAction = type
    },
    closeModal: function () {
      this.modalOpenned = false
    },
    handleMouseup (e) {
      const actionsDropdown = document.getElementById('jsDropdown')
      if (actionsDropdown && !actionsDropdown.contains(e.target)) {
        this.showActionsDropdown = false
      }
    },
    actionInvite (password) {
      this.errors = []
      const actionParams = {
        inviteId: this.inviteId,
        body: { password }
      }
      const msgErrorInternal = this.$t('invite.error-internal')
      const messagesSuccess = {
        RESEND_INVITE: this.$t('invite.success-resend'),
        CANCEL_INVITE: this.$t('invite.success-cancel')
      }

      return this.$store
        .dispatch(this.typeAction, actionParams)
        .then(() => {
          this.alert = {
            show: true,
            isError: false,
            messages: [messagesSuccess[this.typeAction]]
          }
          this.$emit('getInvite')
        })
        .catch(err => {
          this.alert = {
            show: true,
            isError: true,
            messages: formatErrorMessage(err, msgErrorInternal)
          }
          this.closeModal()
        })
    }
  },
  created () {
    document.addEventListener('mouseup', this.handleMouseup, { passive: true })
  },
  beforeDestroy () {
    document.removeEventListener('mouseup', this.handleMouseup)
  }
}
</script>
